import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Route, Switch, Link, NavLink} from "react-router-dom";
import Accountcon from "../container/user/account-container.js";
import Auditscon from "../container/audit/audits-container.js";
import Archivescon from "../container/audit/archives-container.js";
import EditAuditcon from "../container/audit/editAudit-container.js";
import CreateAuditcon from "../container/audit/createAudit-container.js";
import Dashboardcon from "../container/dashboard-container.js";
import Invoicescon from "../container/invoice/invoices-container.js";
import CreateInvoicecon from "../container/invoice/createInvoice-container.js";
import EditInvoicecon from "../container/invoice/editInvoice-container.js";
import Mapcon from "../container/map/map-container.js";
import Parcourscon from "../container/map/parcours-container.js";
import Journeycon from "../container/audit/journey-container.js";
import Reportscon from "../container/report/reports-container.js";
import Reportcon from "../container/report/report-container.js";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import SearchIcon from '@material-ui/icons/Search';
import { fade } from '@material-ui/core/styles/colorManipulator';

import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import CircularProgress from '@material-ui/core/CircularProgress';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import InfoIcon from '@material-ui/icons/Info';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import DescriptionIcon from '@material-ui/icons/Description';
import { mainListItems } from './listItems';
import AutoSuggestAudit from './utils/AutoSuggestAudit';

import 'moment/locale/fr';
import ModalSync from "./utils/ModalSync";
moment.locale('fr');
const drawerWidth = 240;

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
    zIndex: 1,
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    position: 'absolute',
    marginLeft: drawerWidth,
  },
  toolbar: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px',
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
  },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
      marginTop: 64,
      width: "100%",
      flexGrow: 1,
      padding: theme.spacing.unit * 3,
      transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
      overflow: "auto",
    },
    contentShift: {
        marginTop: 64,
        width: "calc(100vw - "+drawerWidth+"px)",
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
        overflow: "auto",
    },
    contentFull: {
        width: "100%",
        flexGrow: 1,
        paddingTop: theme.mixins.toolbar.height,
        height: '100vh',
        overflow: 'hidden',
        marginLeft: -drawerWidth,
    },
  link: {
    textDecoration: 'none',
    outline: 'none'
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
      color: "white",
  },
  appBarSpacer: theme.mixins.toolbar,
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  badgeMenuMargin: {
    margin: `5px 10px 0 0`,
  },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit,
            width: 'auto',
        },
        [theme.breakpoints.down('xs')]: {
            display: "none",
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    splashscreen: {
        backgroundColor: "white",
        opacity: 0.8,
        filter: "alpha(opacity=80)",
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    progress: {
        width: "60px !important",
        height: "60px !important",
    }
});

class App extends React.Component {
  state = {
    mobileOpen: false,
    notifAnchorEl: null,
    anchorEl: null,
  };

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  };

  handleDrawerOpen = () => {
    this.setState({ mobileOpen: true });
  };

  handleDrawerClose = () => {
    this.setState({ mobileOpen: false });
  };

  handleMenu = (e, id) => {
    this.setState({ [id]: e.currentTarget });
  };

  handleMenuClose = (e, id) => {
    this.setState({ [id]: null });
  };

  handleClick = (e, id) => {
    switch(id) {
      case 'account':
        this.props.history.replace('/account')
      break;
      case 'logout':
        this.props.handleLogout();
      break;
      default:
      break;
    }
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, user, auditsCalendarEvents, audits } = this.props;
    const { mobileOpen } = this.state;
    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <AppBar
              position="fixed"
              className={classNames(classes.appBar, {
                  [classes.appBarShift]: mobileOpen,
              })}
          >
          <Toolbar>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={this.handleDrawerToggle}
            className={classes.navIconHide}
          >
            <MenuIcon />
              </IconButton>
              <NavLink className={classes.title} to="/" style={{ textDecoration: 'none' }}>
                  <Typography variant="title" color="inherit" noWrap >
                    Audyssée
                  </Typography>
              </NavLink>
              <div className={classes.search}>
                  <div className={classes.searchIcon}>
                      <SearchIcon />
                  </div>
                  <AutoSuggestAudit suggestions={[...this.props.audits, ...this.props.archives]} history={this.props.history}/>
              </div>
              <div>
                  <ModalSync user={user} auditsCalendarEvents={auditsCalendarEvents} audits={audits} syncAudits={this.props.syncAudits}/>
              </div>
              <div>
                <IconButton
                  aria-owns={this.state.notifAnchorEl ? 'menu-notif' : null}
                  aria-haspopup="true"
                  onClick={(e) => this.handleMenu(e, "notifAnchorEl")}
                  color="inherit"
                >
                  {(this.props.audits.length > 0 &&
                      this.props.audits.filter(audit => (
                          ((audit.status === "waiting" || audit.status === "appointment_notified") && moment().add(3, "month").isSameOrAfter(moment(audit.date_limit))) ||
                          ((audit.status === "valid" || audit.status === "reject" || audit.status === "issue_invoiced" ) && audit.invoices.length === 0)
                      )).length > 0
                  ) ? (
                    <Badge
                      badgeContent={
                        this.props.audits.filter(audit => (
                            ((audit.status === "waiting" || audit.status === "appointment_notified") && moment().add(3, "month").isSameOrAfter(moment(audit.date_limit))) ||
                            ((audit.status === "valid" || audit.status === "reject"|| audit.status === "issue_invoiced" ) && audit.invoices.length === 0)
                        )).length
                      }
                      color="secondary">
                      <NotificationsIcon />
                    </Badge>
                ) : (
                  <NotificationsIcon />
                )}
                </IconButton>
                <Menu
                  id="menu-notif"
                  anchorEl={this.state.notifAnchorEl}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  getContentAnchorEl={null}
                  open={Boolean(this.state.notifAnchorEl)}
                  onClose={(e) => this.handleMenuClose(e, "notifAnchorEl")}
                >
                  {this.props.audits.filter(audit => ((audit.status === "waiting" || audit.status === "appointment_notified") && moment().add(3, "month").isSameOrAfter(moment(audit.date_limit)))).map(audit => {
                    return (
                      <Link to={"/audits/" + audit.id} key={audit.id} className={this.props.classes.link}>
                        <MenuItem className={this.props.classes.menuItem}>
                          <Tooltip title="Audit sans rendez-vous validé (limite dans moins de 3 mois)">
                            <ListItemIcon className={this.props.classes.icon}>
                                {audit.status === "waiting" ? <HourglassEmptyIcon /> : <CalendarTodayIcon />}
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText classes={{ primary: this.props.classes.primary }} inset primary={audit.company.reference + " - " + audit.company.name + " - " + audit.company.department} />
                        </MenuItem>
                      </Link>
                    )
                  })}

                  {this.props.audits.filter(audit => (audit.status === "valid" || audit.status === "reject" || audit.status === "issue_invoiced" ) && audit.invoices.length === 0).map(audit => {
                      return (
                          <Link to={"/audits/" + audit.id} key={audit.id} className={this.props.classes.link}>
                              <MenuItem className={this.props.classes.menuItem}>
                                  <Tooltip title="Audit terminé mais non facturé">
                                      <ListItemIcon className={this.props.classes.icon}>
                                          <DescriptionIcon />
                                      </ListItemIcon>
                                  </Tooltip>
                                  <ListItemText classes={{ primary: this.props.classes.primary }} inset primary={audit.company.reference + " - " + audit.company.name + " - " + audit.company.department} />
                              </MenuItem>
                          </Link>
                      )
                  })}

                </Menu>
              </div>
              <div>
                <IconButton
                  aria-owns={this.state.anchorEl ? 'menu-appbar' : null}
                  aria-haspopup="true"
                  onClick={(e) => this.handleMenu(e, "anchorEl")}
                  color="inherit"
                >
                  {this.props.userInfoMissing ? (
                  <Badge badgeContent="!" color="secondary">
                    <AccountCircle />
                  </Badge>
                ) : (
                  <AccountCircle />
                )}
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={this.state.anchorEl}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  getContentAnchorEl={null}
                  open={Boolean(this.state.anchorEl)}
                  onClose={(e) => this.handleMenuClose(e, "anchorEl")}
                >
                    {this.props.userInfoMissing ? (
                      <MenuItem onClick={(e) => this.handleClick(e, "account")}>
                        <Tooltip title="Des informations sont manquantes">
                          <ListItemIcon className={classes.icon}>
                            <InfoIcon />
                          </ListItemIcon>
                        </Tooltip>
                        <ListItemText classes={{ primary: classes.primary }} inset primary="Mon compte" />
                      </MenuItem>
                    ) : (
                      <Link to="/account" className={this.props.classes.link}>
                        <MenuItem>Mon compte</MenuItem>
                      </Link>
                    )}
                  <MenuItem onClick={(e) => this.handleClick(e, "logout")}>Déconnexion</MenuItem>
                </Menu>
              </div>
            </Toolbar>
          </AppBar>

          <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor='left'
            style={{height: "100%"}}
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
          <div>
              <div className={classes.toolbar}>
                  <IconButton onClick={this.handleDrawerClose}>
                      <ChevronLeftIcon />
                  </IconButton>
              </div>
            <Divider />
            <List>{mainListItems}</List>
          </div>
          </Drawer>

            <main className={this.props.history.location.pathname !== "/map" ? classNames(classes.content, {
                [classes.contentShift]: mobileOpen,
            }) : classes.contentFull}>

              <Switch>
              <Route exact path={'/'} component={Dashboardcon} />
              <Route exact path={'/account'} component={Accountcon} />
              <Route exact path={'/archives'} component={Archivescon} />
              <Route exact path={'/audits'} component={Auditscon} />
              <Route exact path={'/audits/new'} component={CreateAuditcon} />
              <Route path={'/audits/:id([0-9]*)'} component={EditAuditcon} />
              <Route exact path={'/invoices'} component={Invoicescon} />
              <Route exact path={'/invoices/new'} component={CreateInvoicecon} />
              <Route path={'/invoices/:id([0-9]*)'} component={EditInvoicecon} />
              <Route exact path={'/map'} component={Mapcon} />
              <Route exact path={'/parcours'} component={Parcourscon} />
              <Route exact path={'/journey'} component={Journeycon} />
              <Route exact path={'/reports'} component={Reportscon} />
              <Route path={'/reports/:id([0-9]*)'} component={Reportcon} />
              </Switch>

                {this.props.loading && <div id={"splashscreen"} className={classes.splashscreen}>
                    <CircularProgress className={classes.progress} />
                </div>}

          </main>
        </div>
      </React.Fragment>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/component/app.js